<template>
  <div class="detalhes-beneficios">
    <div class="row">
      <public-header :title="beneficio.nome">
        <div class="col-xs-12 col-sm-6">
          <p v-html="descricao_limpa"></p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <bar-chart
            ref="beneficios_mensais"
            :chart-data="graficoHeader"
            :gradiente="false"
            :coloredLine="true"
            :options="{
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: 'Benefícios Mensais',
                fontColor: '#C1D1C1'
              },
              legend: {
                display: true,
                labels: {
                  fontColor: '#C1D1C1',
                },
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50,
                      fontColor: '#C1D1C1',
                      callback: function (value, index, values) {
                        return value.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      },
                    },
                  },
                ],
                xAxes: [
                  {
                    maxBarThickness: 50,
                    ticks: {
                      fontColor: '#C1D1C1',
                    },
                  },
                ],
              },
              tooltips: {
                callbacks: {
                  label: function (tooltip, dataset) {
                    var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                    return 'Valor: ' + yLabel
                  },
                },
              },
            }"
          ></bar-chart>
          <p>Total de benefícios: <span class="destaque-header">{{ (total_ano.total).toLocaleString() }}</span></p>
          <p>Valor total: <span class="destaque-header">{{ formatarMoeda(Number(total_ano.valor)) }}</span></p>
        </div>
      </public-header>
    </div>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li><router-link :to="'/assistencia'">Benefícios Assistenciais</router-link></li>
          <li>{{ beneficio.nome }}</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Lista de Beneficiados</h3>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-4">
          <label>Mês de referência</label>
          <select v-model="filtros.mes" class="form-control" @change="atualizaGrid()">
            <option value="">-- Selecione --</option>
            <option v-for="(mes, index) in meses" :key="mes" :value="index + 1">
              {{ mes }}
            </option>
          </select>
        </div>
        <div class="col-sm-8">
          <label>Nome</label>
          <input type="text" v-model="filtros.nome" class="form-control" @change="atualizaGrid()" placeholder="Digite o nome que deseja filtrar..." />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <data-table
            ref="dt"
            :has-auth="false"
            api-url="assistencia/pagamentos/listar"
            :show-empty="true"
            :fields="fields"
            :append-params="filtros"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarPeriodo(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BarChart, PublicHeader } from '../../../components/common/'
import DataTable from '../../../components/common/DataTablePublic'
import { formatarMoeda, mesesAbr, mesesExt } from '../../../utils/strings'
import { request } from '../../../request'
import { mapState } from 'vuex'

export default {
  components: { PublicHeader, BarChart, DataTable },
  data () {
    return {
      meses: mesesExt,
      grafico_base: { labels: [], datasets: [{ label: '', data: [] }] },
      beneficio: {},
      total_mes: [],
      total_ano: { total: 0, valor: 0 },
      pagamentos: [],
      meses: mesesExt,
      filtros: {
        nome: '',
        ano: '',
        mes: '',
        beneficio: ''
      },
      fields: [
        {
          name: 'data',
          title: 'Data',
          callback (value) {
            return new Date(`${value}`).toLocaleDateString()
          }
        },
        {
          name: 'beneficiado',
          title: 'Nome'
        },
        {
          name: 'beneficio.sigla',
          title: 'Benefício',
        },
        {
          name: '__slot:column',
          title: 'Período',
        },
        {
          name: 'valor',
          title: 'Valor',
          titleClass: 'text-right',
          dataClass: 'text-right',
          callback (value) {
            return formatarMoeda(Number(value))
          }
        }
      ],
    }
  },
  beforeMount () {
    const { item, sigla } = this.$route.params
    this.filtros.ano = this.ano_base

    if (item) {
      this.beneficio = { ...item }
      this.filtros.beneficio = this.beneficio.codigo
    } else {
      this.carregaBeneficio(sigla)
    }
  },
  created () {
    const { sigla } = this.$route.params
    this.carregaPagamentos(sigla)
  },
  methods: {
    retornarPeriodo (props) {
      if (props.periodo_inicio && props.periodo_fim) {
        return `de ${new Date(props.periodo_inicio).toLocaleDateString()}
                à ${new Date(props.periodo_fim).toLocaleDateString()}`
      }

      return '_________'
    },
    formatarMoeda,
    carregaBeneficio (sigla) {
      request
        .get('/assistencia/listar-beneficios')
        .then(response => {
          const { data } = response

          const filter = item => {
            return item.sigla === sigla
          }

          this.beneficio = _.first(data.filter(filter))
          this.filtros.beneficio = this.beneficio.codigo

          this.$refs.dt.refresh()
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e('Houve um erro ao carregar a lista de benefícios. Atualize a página e, caso o problema persista, contate o administrador.')
          console.log(data.msg)
        })
    },
    carregaPagamentos (sigla) {
      request
        .get(`assistencia/pagamentos-mes/${this.ano_base}/${sigla}`)
        .then(response => {
          const { data } = response
          this.total_mes = data
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e('Houve um erro ao carregar a lista de pagamentos. Atualize a página e, caso o problema persista, contate o administrador.')
        })

      request
        .get('/assistencia/pagamentos-ano/' + this.ano_base)
        .then(response => {
          const { data } = response
          const filter = item => {
            return item.beneficio === sigla
          }

          const total = _.first(data.filter(filter))

          if (total) {
            this.total_ano = total
          }
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e('Houve um erro ao carregar os totais por ano. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.')
          console.log(data.msg)
        })
        .then(() => {
          this.carregando = false
        })
    },
    atualizaGrid () {
      this.$refs.dt.refresh()
    }
  },
  computed: {
    ...mapState({
      ano_base: state => state.receitas_despesas.ano_base
    }),
    listaBeneficiados () {
      const filter = item => {
        return new Date(item.data).getMonth() === (this.filtros.mes - 1)
      }

      if (this.filtros.mes === 0) {
        return this.pagamentos
      }

      return this.pagamentos.filter(filter)
    },
    descricao_limpa () {
      const { descricao } = this.beneficio

      if (descricao) {
        return descricao.replace(/\r\n|\n|\r/g, '<br/>')
      }

      return ''
    },
    graficoHeader () {
      const labels = [...mesesAbr]
      const data = Array(12).fill(0)

      this.total_mes.forEach(element => {
        data[element.mes - 1] = element.valor
      })

      const datasets = [{
        label: this.ano_base,
        data
      }]

      return {
        ...this.grafico_base,
        labels,
        datasets
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/assistencia/Detalhes.vue